module.exports = __webpack_public_path__ + "media/components/footer/static/icon__top-border-107ffae0ad97b50c00093a47d039514d.svg";